// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TargetTypes } from "./Shared.TargetTypes.gen";
import { FacilityCountBaselineSource } from "./FacilityCountBaselineSource.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IFacilityCountBaseline {
	id: string | undefined;

	facilityId: string;

	count: number;

	asOfDate: string;

	targetFilter: TargetTypes | number ;

	source: FacilityCountBaselineSource;

	groundTruthJobId: string | undefined;

	createdById: string | undefined;

	createdDate: string | undefined;

	notes: string | undefined;

	$type?: string | undefined;
}
export class FacilityCountBaseline {
	constructor(data?: IFacilityCountBaseline) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.asOfDate = new Date(data.asOfDate);
		if (data.createdDate) { this.createdDate = new Date(data.createdDate); }
	}

	id: string | undefined;

	@IsNotEmpty()
	facilityId: string = "";

	@IsNotEmpty()
	count: number = 0;

	@IsNotEmpty()
	asOfDate: Date = new Date();

	targetFilter: TargetTypes | number  = 0;

	source: FacilityCountBaselineSource = 0;

	groundTruthJobId: string | undefined;

	createdById: string | undefined;

	createdDate: Date | undefined = new Date();

	notes: string | undefined;

	static $type: string = "CoreApi.Models.FacilityCountBaseline, ";
	$type?: string | undefined = FacilityCountBaseline.$type;
}

